import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { UpdateUserEmailRequest } from "swagger/models"
import { UserApi } from "../../../swagger/api"
import { Configuration } from "../../../swagger/configuration"
import { getFirebaseIDToken } from "../auth/firebase"

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken
}

const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    //@ts-ignore
    accessToken: getAccessToken,
  })

const apiConfiguration = getApiConfig()

const PLAYER_API = new UserApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const register = async (options?: AxiosRequestConfig) => PLAYER_API.register(options)
export const updatePlayerEmail = async (body: UpdateUserEmailRequest, options?: AxiosRequestConfig) =>
  PLAYER_API.updateUserEmail(body, options)
